export var DEFAULT_TIME_ZONE_NAME = 'America/Los_Angeles';
//# sourceMappingURL=Constant.js.map